export default [
  {
    path: '/funcionario',
    name: 'Funcionário',
    component: () => import('./FuncionarioList'),
    meta: {
      routerGo: '/funcionario-new',
      routerEdit: '/funcionario-edit',
      domain: 'Funcionario',
      sidebar: true,
      icon: 'account_circle',
      title: 'Funcionário',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Funcionario/FuncionarioRouter.js